module.exports = __webpack_public_path__ + "media/puzzle3_1.d87df77f.mp3";